module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-latin-ext-700-normal.woff2?ed67ad54b1a8f5d211503d1685cd9249";